__turbopack_context__.v({
  "root": "BottomBar-module__4lkIeW__root",
  "styledPrimaryButton": "BottomBar-module__4lkIeW__styledPrimaryButton",
});
